import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { Dialog } from 'material-ui';
import { Card, CardActions } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ContentCreate from 'material-ui/svg-icons/content/create';

import ViewTitle from "components/layout/ViewTitle";
import { List, Datagrid } from 'components/list';
import { TextField } from 'components/field';
import { BooleanInput } from 'components/input';
import { TriggerCreate } from './TriggerCreate';
import { TriggerCreateTH } from './TriggerCreateTH';
import { crudUpdate as crudUpdateAction } from 'actions/dataActions';

import * as urls from '../urls';
import * as utils from '../utils';
import { COUNTRY_TH } from 'util/constants';


const styles = {
  cardActionStyle: {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
  },
  flat: {
      overflow: 'inherit',
  },
};

const CustomTextField = (props) => {
  const _record = { ...(props.record || {}) };

  _record.product_val = (_record.product || {}).name;
  _record.benefit_val = `${ _record.benefit.category} - ${ _record.benefit.parameter}`;

  return (
    <TextField 
      {...props}
      record={_record}
    />
  )
};

const CustomBooleanField = (props) => {
  return (
    <BooleanInput
      onClick={async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await props.setSelectedTrigger(props.record);
        props.setIsConfirmDialogOpen(true);
      }}
      input={{
        onChange: () => {},
        value: !!props.record.is_active,
      }}
      customLabelStyle={{
        display: 'none',
      }}
      toggled={!!props.record.is_active}
    />
  );
};

const CustomEditField = (props) => {
  return (
    <FlatButton
      primary
      label='Edit'
      icon={<ContentCreate />}
      onClick={() => {
        props.setEdit(props.record);
      }}
      style={{ overflow: 'inherit' }}
    />
  );
};

class TriggerListBase extends Component {
  state = {
    isDialogOpen: false,
    isConfirmDialogOpen: false,
    selectedTrigger: null,
    isInlineUpdate: false,
  }

  setIsDialogOpen = (dialog_open) => {
    this.setState({
      isDialogOpen: !!dialog_open,
    });
  }

  setIsConfirmDialogOpen = (dialog_open) => {
    this.setState({
      isConfirmDialogOpen: !!dialog_open,
    });
  }

  setSelectedTrigger = (trigger) => {
    this.setState({
      selectedTrigger: trigger,
    });
  }

  setIsInlineUpdate = (inline_update) => {
    this.setState({
      isInlineUpdate: !!inline_update,
    });
  }

  render() {
    const record = this.state.selectedTrigger;
    const TriggerCreateBase = process.env.REACT_APP_COUNTRY === COUNTRY_TH ? TriggerCreateTH : TriggerCreate; 
    return (
      <div>
        {(
          this.props.isLoading
          && !this.state.isInlineUpdate
        ) ? (
          <div className="list-page">
            <Card style={{ opacity: 0.8 }}>
              <ViewTitle title={'Triggers'} />
              <div style={{ padding: '1em' }}>
                Loading ...
              </div>
            </Card>
          </div>
        ) : (
          <Route 
            render={(props) => (
              <List
                {...props}
                title={'Triggers'}
                resource={utils.PromotionTriggerResourceName}
                hasCreate={false}
                actions={(
                  <CardActions style={styles.cardActionStyle}>
                    <FlatButton
                      primary
                      label={'Add Trigger'}
                      icon={<ContentAdd />}
                      onClick={() => {
                        this.setSelectedTrigger(null);
                        this.setIsDialogOpen(true);
                      }}
                      style={styles.flat}
                    />
                  </CardActions>
                )}
              >
                <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
                  <TextField source="id" label="ID"/>
                  <CustomTextField source="product_val" label="Product" />
                  <CustomTextField source="benefit_val" label="Benefit" />
                  <CustomBooleanField 
                    label="Enabled"
                    setSelectedTrigger={this.setSelectedTrigger}
                    setIsConfirmDialogOpen={this.setIsConfirmDialogOpen}
                    style={{ textAlign: 'center' }}
                  />
                  <CustomEditField 
                    label="Edit"
                    setEdit={(record) => {
                      this.setSelectedTrigger(record);
                      this.setIsDialogOpen(true);
                    }}
                  />
                </Datagrid>
              </List>
            )}
          />
        )}

        <Dialog
          title={this.state.selectedTrigger ? 'Edit Promotion Trigger' : 'Add Promotion Trigger'}
          open={this.state.isDialogOpen}
          onRequestClose={() => {
            this.setIsDialogOpen(false);
          }}
        >
          <TriggerCreateBase 
            promotion_id={this.props.promotion_id}
            products={this.props.products}
            benefits={this.props.benefits}
            resource={utils.PromotionTriggerResourceName}
            _record={this.state.selectedTrigger}
            closeDialog={() => {
              this.setIsDialogOpen(false);
            }}
            refresh={this.props.refreshTriggerList}
          />  
        </Dialog>
        
        <Dialog
          title='Confirm change trigger status'
          open={this.state.isConfirmDialogOpen}
          actions={[
            <FlatButton
              label="Cancel"
              onTouchTap={() => {
                this.setIsConfirmDialogOpen(false);
              }}
            />,
            <FlatButton
              label="Change"
              primary={true}
              onTouchTap={async () => {
                if (record) {
                  await this.setIsInlineUpdate(true);
                  await this.props.crudUpdate(
                    utils.PromotionTriggerResourceName,
                    record.id,
                    {
                      ...(record),
                      promotion: record.promotion.id,
                      product: record.product.id,
                      benefit: record.benefit.id,
                      is_active: !record.is_active,
                    },
                    {
                      ...(record),
                      promotion: record.promotion.id,
                      product: record.product.id,
                      benefit: record.benefit.id,
                      is_active: record.is_active,
                    },
                    urls.promotionTriggerBackendPath,
                    '',
                    'Trigger has been updated',
                    () => {
                      this.props.refreshTriggerList();
                      this.setIsInlineUpdate(false);
                      this.setIsConfirmDialogOpen(false);
                    }
                  );
                }
              }}
            />,
          ]}
          onRequestClose={() => {
            this.setIsConfirmDialogOpen(false);
          }}
        >
          { (record && record.is_active) 
            ? 'Are you sure you want to disable this trigger?'
            : 'Are you sure you want to enable this trigger?'
          }
        </Dialog>
      </div>
    );
  }
}

export const TriggerList = connect(
  (state) => {
    return {
      isLoading: !!state.admin.loading,
      products: state.admin[utils.ProductResourceName].data,
      benefits: state.admin[utils.PromotionBenefitResourceName].data,
      triggers: state.admin[utils.PromotionTriggerResourceName].data,
    }
  },
  {
    crudUpdate: crudUpdateAction,
  },
)(TriggerListBase);



// WEBPACK FOOTER //
// ./src/routes/product/PromotionEdit/TriggerList.js